import React from 'react'
import { useResource } from "../../../Hooks/UseResource";

function PersonalDetailsResource() {
     const [resourceError, loading, getData, postData] = useResource();


     const getCallBackUrlAadharXml = (applicationSessionToken, holderType) => {
          return postData({
               url: 'public/aadhar-xml-create-profile', data: {
                    "appKey": applicationSessionToken,
                    "holderType": holderType
               }
          })
     }

     const switchJourney = (kycApplicationId, holderType,appKey) => {
          return postData({
               url: 'public/switch-journey', data: {
                    "kycApplicationId": kycApplicationId,
                    "holderType": holderType,
                    "appKey":appKey
               }
          })
     }
    

     return {getCallBackUrlAadharXml,switchJourney}

}

export default PersonalDetailsResource
